<template>
  <Combobox
    name="timezone"
    v-model="selectedTimezone"
    :options="timezones.map(timezone => ({ value: timezone.value, label: timezone.name }))"
    :fullwidth="true"
    required
  />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import Combobox from "@/components/ui/Combobox.vue";

const props = defineProps({
  timezones: {
    type: Array,
    required: true
  },
  value: {
    type: String,
    default: null
  },
});

const emit = defineEmits(["timezone-change"]);
const selectedTimezone = ref(props.value);

watch(() => props.value, (newZone) => {
  selectedTimezone.value = newZone;
}, { immediate: true });

watch(selectedTimezone, (newTimezone) => {
  emit("timezone-change", newTimezone);
});
</script>
